import axios from 'axios';

const getUrl = url => {
  if (window.location.href.includes('localhost')) {
    return `http://dev2.awto.pro${url}`;
  } else {
    return url;
  }
};

export const httpClient = axios.create({
  baseURL: getUrl('/awto/api/'),
  headers: {
    'Content-Type': 'application/json',
  },
});

export const httpRootClient = axios.create({
  baseURL: getUrl('/'),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default httpClient;
